/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IPublishedContentType } from './IPublishedContentType';
import {
    IPublishedContentTypeFromJSON,
    IPublishedContentTypeFromJSONTyped,
    IPublishedContentTypeToJSON,
} from './IPublishedContentType';
import type { IPublishedProperty } from './IPublishedProperty';
import {
    IPublishedPropertyFromJSON,
    IPublishedPropertyFromJSONTyped,
    IPublishedPropertyToJSON,
} from './IPublishedProperty';
import type { PublishedCultureInfo } from './PublishedCultureInfo';
import {
    PublishedCultureInfoFromJSON,
    PublishedCultureInfoFromJSONTyped,
    PublishedCultureInfoToJSON,
} from './PublishedCultureInfo';
import type { PublishedItemType } from './PublishedItemType';
import {
    PublishedItemTypeFromJSON,
    PublishedItemTypeFromJSONTyped,
    PublishedItemTypeToJSON,
} from './PublishedItemType';

/**
 * 
 * @export
 * @interface IPublishedContent
 */
export interface IPublishedContent {
    /**
     * 
     * @type {IPublishedContentType}
     * @memberof IPublishedContent
     */
    contentType?: IPublishedContentType;
    /**
     * 
     * @type {string}
     * @memberof IPublishedContent
     */
    readonly key?: string;
    /**
     * 
     * @type {Array<IPublishedProperty>}
     * @memberof IPublishedContent
     */
    readonly properties?: Array<IPublishedProperty>;
    /**
     * 
     * @type {number}
     * @memberof IPublishedContent
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPublishedContent
     */
    readonly name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPublishedContent
     */
    readonly urlSegment?: string;
    /**
     * 
     * @type {number}
     * @memberof IPublishedContent
     */
    readonly sortOrder?: number;
    /**
     * 
     * @type {number}
     * @memberof IPublishedContent
     */
    readonly level?: number;
    /**
     * 
     * @type {string}
     * @memberof IPublishedContent
     */
    readonly path?: string;
    /**
     * 
     * @type {number}
     * @memberof IPublishedContent
     */
    readonly templateId?: number;
    /**
     * 
     * @type {number}
     * @memberof IPublishedContent
     */
    readonly creatorId?: number;
    /**
     * 
     * @type {Date}
     * @memberof IPublishedContent
     */
    readonly createDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof IPublishedContent
     */
    readonly writerId?: number;
    /**
     * 
     * @type {Date}
     * @memberof IPublishedContent
     */
    readonly updateDate?: Date;
    /**
     * 
     * @type {{ [key: string]: PublishedCultureInfo; }}
     * @memberof IPublishedContent
     */
    readonly cultures?: { [key: string]: PublishedCultureInfo; };
    /**
     * 
     * @type {PublishedItemType}
     * @memberof IPublishedContent
     */
    itemType?: PublishedItemType;
    /**
     * 
     * @type {IPublishedContent}
     * @memberof IPublishedContent
     */
    parent?: IPublishedContent;
    /**
     * 
     * @type {Array<IPublishedContent>}
     * @memberof IPublishedContent
     */
    readonly children?: Array<IPublishedContent>;
    /**
     * 
     * @type {Array<IPublishedContent>}
     * @memberof IPublishedContent
     */
    readonly childrenForAllCultures?: Array<IPublishedContent>;
}

/**
 * Check if a given object implements the IPublishedContent interface.
 */
export function instanceOfIPublishedContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IPublishedContentFromJSON(json: any): IPublishedContent {
    return IPublishedContentFromJSONTyped(json, false);
}

export function IPublishedContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPublishedContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contentType': !exists(json, 'ContentType') ? undefined : IPublishedContentTypeFromJSON(json['ContentType']),
        'key': !exists(json, 'Key') ? undefined : json['Key'],
        'properties': !exists(json, 'Properties') ? undefined : ((json['Properties'] as Array<any>).map(IPublishedPropertyFromJSON)),
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'name': !exists(json, 'Name') ? undefined : json['Name'],
        'urlSegment': !exists(json, 'UrlSegment') ? undefined : json['UrlSegment'],
        'sortOrder': !exists(json, 'SortOrder') ? undefined : json['SortOrder'],
        'level': !exists(json, 'Level') ? undefined : json['Level'],
        'path': !exists(json, 'Path') ? undefined : json['Path'],
        'templateId': !exists(json, 'TemplateId') ? undefined : json['TemplateId'],
        'creatorId': !exists(json, 'CreatorId') ? undefined : json['CreatorId'],
        'createDate': !exists(json, 'CreateDate') ? undefined : (new Date(json['CreateDate'])),
        'writerId': !exists(json, 'WriterId') ? undefined : json['WriterId'],
        'updateDate': !exists(json, 'UpdateDate') ? undefined : (new Date(json['UpdateDate'])),
        'cultures': !exists(json, 'Cultures') ? undefined : (mapValues(json['Cultures'], PublishedCultureInfoFromJSON)),
        'itemType': !exists(json, 'ItemType') ? undefined : PublishedItemTypeFromJSON(json['ItemType']),
        'parent': !exists(json, 'Parent') ? undefined : IPublishedContentFromJSON(json['Parent']),
        'children': !exists(json, 'Children') ? undefined : ((json['Children'] as Array<any>).map(IPublishedContentFromJSON)),
        'childrenForAllCultures': !exists(json, 'ChildrenForAllCultures') ? undefined : ((json['ChildrenForAllCultures'] as Array<any>).map(IPublishedContentFromJSON)),
    };
}

export function IPublishedContentToJSON(value?: IPublishedContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ContentType': IPublishedContentTypeToJSON(value.contentType),
        'ItemType': PublishedItemTypeToJSON(value.itemType),
        'Parent': IPublishedContentToJSON(value.parent),
    };
}

